import {
  List,
  Datagrid,
  TextField,
  NumberField,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  SearchInput,
  FunctionField,
  required,
  minValue,
} from "react-admin";
import { Box, Chip } from "@mui/material";

const ROLES = [
  { id: "Portiere", name: "Portiere" },
  { id: "Difensore", name: "Difensore" },
  { id: "Centrocampista", name: "Centrocampista" },
  { id: "Attaccante", name: "Attaccante" },
];

const playerFilters = [
  <SearchInput key="q" source="q" alwaysOn placeholder="Cerca giocatore..." />,
  <SelectInput
    key="role"
    source="role"
    choices={ROLES}
    label="Ruolo"
    alwaysOn={false}
    emptyText="Tutti i ruoli"
  />,
];

const RoleChip = (record) => {
  const role = record?.role;
  if (!role) return null;

  // chip semplice (senza colori custom, così non ti “rompe” il tema)
  return <Chip size="small" label={role} variant="outlined" />;
};

export const PlayerList = () => (
  <List
    filters={playerFilters}
    perPage={25}
    sort={{ field: "name", order: "ASC" }}
    sx={{
      "& .RaList-content": { marginTop: 1 },
    }}
  >
    <Datagrid
      rowClick="edit"
      bulkActionButtons={false}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        "& .RaDatagrid-headerCell": {
          fontWeight: 800,
        },
        "& .RaDatagrid-rowCell": {
          py: 1.25,
        },
      }}
    >
      <TextField source="id" label="ID" />
      <TextField source="name" label="Nome" />
      <FunctionField label="Ruolo" render={(record) => RoleChip(record)} />
      <NumberField source="number" label="N°" />
    </Datagrid>
  </List>
);

const PlayerForm = () => (
  <SimpleForm>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        gap: 2,
      }}
    >
      <TextInput
        source="name"
        label="Nome"
        validate={[required()]}
        fullWidth
      />

      <SelectInput
        source="role"
        label="Ruolo"
        choices={ROLES}
        validate={[required()]}
        fullWidth
      />

      <NumberInput
        source="number"
        label="Numero maglia"
        validate={[required(), minValue(1)]}
        fullWidth
      />
    </Box>
  </SimpleForm>
);

export const PlayerEdit = () => (
  <Edit title="Modifica giocatore">
    <PlayerForm />
  </Edit>
);

export const PlayerCreate = () => (
  <Create title="Nuovo giocatore">
    <PlayerForm />
  </Create>
);
